import CommunityPods from '@/components/community-pods/CommunityPods';
import { SubscriptionGuard } from '@/components/ui/subscription-guard';

export default function CommunityPodsPage() {
  return (
    <SubscriptionGuard feature="community_pods">
      <CommunityPods />
    </SubscriptionGuard>
  );
}